























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { mapGetters } from "vuex";
import EITQuarterList, { IncomeTaxDeclarationOne } from "./EITQuarterList";
import EITQuarterTwo, { IncomeTaxDeclarationTwo } from "./EITQuarterTwo";
import EITQuarterThree, { IncomeTaxDeclarationThree } from "./EITQuarterThree";
import EITQuarterFour, { IncomeTaxDeclarationFour } from "./EITQuarterFour";
// 引入表格数据
@Component({
    ...mapGetters(["accountBook"]),
    components: {}
})
export default class EITQuarterTable extends Vue {
    @Prop({ type: String })
    activeTab?: string;

    @Prop({ type: [Object, Array] })
    curData!: any;

    @Prop({ type: Object })
    curAccount!: any;

    isTechSmall: number = 1; //科技中小企业
    isTechHigh: number = 1; //高新技术
    isTechShare: number = 1; //技术入股
    isStateLimit: number = 1; //国家限制
    isSmallLowProfit: number = 0; //小微企业
    payment: number = 0; //预缴方式
    enterprise: number = 0; //企业类型
    startPersonNum: string = "";
    endPersonNum: string = "";
    startAssets: string = "";
    endAssets: string = "";
    inputRow: IncomeTaxDeclarationOne[] = EITQuarterList; //主表
    inputRow2: IncomeTaxDeclarationTwo[] = EITQuarterTwo; //附表一
    inputRow3: IncomeTaxDeclarationThree[] = EITQuarterThree; //附表二
    inputRow4: IncomeTaxDeclarationFour[] = EITQuarterFour; //附表三
    inputRow6: IncomeTax.IncomeTaxFive = {
        id: null,
        accountBookId: "", //帐套
        startPeriod: "", //起始期间
        endPeriod: "", //结束期间
        name: "", //技术成果名称
        type: "", //技术成果类型
        code: "", //技术成果编号
        fairValue: "", //公允价值
        taxBase: "", //计税基础
        acquisitionDate: "", //取得股权时间（年月日）
        deferredIncome: "", //递延所得
        companyName: "", //企业名称
        taxPayerCode: "", //纳税人识别号
        taxAuthorities: "", //主管税务机关
        investor: "", //与投资方是否为
        remark: "", //备注
        writePeriod: ""
    }; //附表五新增行
    period: string = "";
    isL15: number = 0;
    mounted() {
        if (this.curAccount) {
            this.period = this.curAccount.startPeriod;
        }
    }

    //获取表格数据
    fetchData() {
        if (this.curData) {
            // 主表
            if (this.activeTab === "incomeTaxDeclarationMain") {
                let i = 0;
                let j = 1;
                while (i <= this.inputRow.length - 1) {
                    if (
                        this.inputRow[i].amount != undefined &&
                        !this.inputRow[i].isHead
                    ) {
                        if (i < 16) {
                            if (this.curData["row" + j] != undefined) {
                                this.inputRow[i].amount = this.curData["row" + j];
                            }
                        }
                        if (i === 16) this.inputRow[16].amount = this.curData.rowL15;
                        if (i > 16) {
                            this.inputRow[i].amount = this.curData["row" + j];
                        }
                        if (i != 16) j++;
                    }
                    i++;
                }
                this.startPersonNum = this.curData.startPersonNum;
                this.endPersonNum = this.curData.endPersonNum;
                this.startAssets = this.curData.startAssets;
                this.endAssets = this.curData.endAssets;
                this.isTechHigh = this.curData.isTechHigh;
                this.isSmallLowProfit = this.curData.isSmallLowProfit;
                this.isTechSmall = this.curData.isTechSmall;
                this.isTechShare = this.curData.isTechShare;
                this.isStateLimit = this.curData.isStateLimit;
                this.payment = this.curData.payType;
                this.enterprise = this.curData.companyType;
                this.startPersonNum1 = this.curData.startPersonNum1;
                this.endPersonNum1 = this.curData.endPersonNum1;
                this.startPersonNum2 = this.curData.startPersonNum2;
                this.endPersonNum2 = this.curData.endPersonNum2;
                this.startPersonNum3 = this.curData.startPersonNum3;
                this.endPersonNum3 = this.curData.endPersonNum3;
                this.startPersonNum4 = this.curData.startPersonNum4;
                this.endPersonNum4 = this.curData.endPersonNum4;
                this.startAssets1 = this.curData.startAssets1;
                this.endAssets1 = this.curData.endAssets1;
                this.startAssets2 = this.curData.startAssets2;
                this.endAssets2 = this.curData.endAssets2;
                this.startAssets3 = this.curData.startAssets3;
                this.endAssets3 = this.curData.endAssets3;
                this.startAssets4 = this.curData.startAssets4;
                this.endAssets4 = this.curData.endAssets4;
                this.assetsAvg = this.curData.assetsAvg;
                this.personNumAvg = this.curData.personNumAvg;
            } else if (this.activeTab === "incomeTaxDeclarationTwo") {
                if (this.curData) {
                    for (let i = 0; i < this.inputRow2.length; i++) {
                        if (!this.inputRow2[i].isHead) {
                            let index = Number(this.inputRow2[i].row);
                            if (this.curData[i]) this.inputRow2[i].amount = this.curData[i].balance;
                        }
                    }
                }
            } else if (this.activeTab === "incomeTaxDeclarationThree") {
                if (this.curData) {
                    this.curData.forEach((v: any, i: number) => {
                        Object.keys(v).forEach(attr => {
                            // @ts-ignore
                            this.inputRow3[i][attr] = v[attr];
                        });
                    });
                }
            } else if (this.activeTab === "incomeTaxDeclarationFour") {
                for (let i = 0; i < this.inputRow4.length; i++) {
                    if (!this.inputRow4[i].isHead) {
                        let index = Number(this.inputRow4[i].row);
                        if (this.curData[i]) {
                            this.inputRow4[i].amount = this.curData[i].balance;
                        }
                    }
                }
            }
        }
    }

    @Watch("curData", { deep: true })
    dataChange(val: any) {
        this.fetchData();
    }
    startPersonNum1: string = "";
    endPersonNum1: string = "";
    startPersonNum2: string = "";
    endPersonNum2: string = "";
    startPersonNum3: string = "";
    endPersonNum3: string = "";
    startPersonNum4: string = "";
    endPersonNum4: string = "";
    startAssets1: string = "";
    endAssets1: string = "";
    startAssets2: string = "";
    endAssets2: string = "";
    startAssets3: string = "";
    endAssets3: string = "";
    startAssets4: string = "";
    endAssets4: string = "";
    assetsAvg: string = "";
    personNumAvg: string = ""
    // 主表
    changeInput(row?: IncomeTaxDeclarationOne | null, name?: string) {
        this.curData.isTechHigh = this.isTechHigh;
        this.curData.isSmallLowProfit = this.isSmallLowProfit;
        this.curData.isTechSmall = this.isTechSmall;
        this.curData.isTechShare = this.isTechShare;
        this.curData.isStateLimit = this.isStateLimit;
        this.curData.payType = this.payment;
        this.curData.companyType = this.enterprise;
        this.curData.endAssets = this.endAssets;
        this.curData.endPersonNum = this.endPersonNum;
        this.curData.startAssets = this.startAssets;
        this.curData.startPersonNum = this.startPersonNum;
        this.curData.startPersonNum1 = this.startPersonNum1;
        this.curData.endPersonNum1 = this.endPersonNum1;
        this.curData.startPersonNum2 = this.startPersonNum2;
        this.curData.endPersonNum2 = this.endPersonNum2;
        this.curData.startPersonNum3 = this.startPersonNum3;
        this.curData.endPersonNum3 = this.endPersonNum3;
        this.curData.startPersonNum4 = this.startPersonNum4;
        this.curData.endPersonNum4 = this.endPersonNum4;
        this.curData.startAssets1 = this.startAssets1;
        this.curData.endAssets1 = this.endAssets1;
        this.curData.startAssets2 = this.startAssets2;
        this.curData.endAssets2 = this.endAssets2;
        this.curData.startAssets3 = this.startAssets3;
        this.curData.endAssets3 = this.endAssets3;
        this.curData.startAssets4 = this.startAssets4;
        this.curData.endAssets4 = this.endAssets4;
        this.curData.assetsAvg = this.assetsAvg;
        this.curData.personNumAvg = this.personNumAvg;
        if (row) {
            if (row.attr) this.curData[row.attr] = row.amount;
        }
        if (name) this.curData.changeTypeName = name
        else this.curData.changeTypeName = ""
        Vue.axios
            .post(
                `enterpriseincometaxquartermain?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`,
                this.curData
            )
            .then(res => {
                this.$emit("update");
            });
    }
    // 附表一
    changeTableOne(row: any) {
        if (row) {
            this.curData[row.row].balance = row.amount;
        }
        Vue.axios
            .post(
                `enterpriseincometaxquarterone?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`,
                this.curData[row.row]
            )
            .then(res => {
                this.$emit("update");
            });
    }
    // 附表二
    changeTableTwo(row: any) {
        Vue.axios
            .post(
                `enterpriseincometaxquartertwo?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`,
                row
            )
            .then(res => {
                this.$emit("update");
            });
    }
    // 附表三
    changeTableThree(row: any) {
        if (row) {
            this.curData[row.row].balance = row.amount;
        }
        Vue.axios
            .post(
                `enterpriseincometaxquarterthree?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`,
                this.curData[row.row]
            )
            .then(res => {
                this.$emit("update");
            });
    }
    // 附表四
    changeTableFour() {
        if (this.curData.officeDate != "") {
            this.curData.officeDate = this.$utils.simpleDateFormat(this.curData.officeDate, "d");
        }
        if (this.curData.resignationDate != "") {
            this.curData.resignationDate = this.$utils.simpleDateFormat(this.curData.resignationDate, "d");
        }
        if (this.curData.transactionDate != "") {
            this.curData.transactionDate = this.$utils.simpleDateFormat(this.curData.transactionDate, "d");
        }
        if (this.curData.disposalDate != "") {
            this.curData.disposalDate = this.$utils.simpleDateFormat(this.curData.disposalDate, "d");
        }
        if (this.curData.achieveTenPercentDate != "") {
            this.curData.achieveTenPercentDate = this.$utils.simpleDateFormat(this.curData.achieveTenPercentDate, "d");
        }
        Vue.axios
            .post(
                `enterpriseincometaxquarterfour?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`,
                this.curData
            )
            .then(res => {
                this.$emit("update");
            });
    }
    // 附表五新增行
    newTableFive() {
        let notNull = this.isNull(this.inputRow6);
        if (notNull && this.inputRow6.acquisitionDate) {
            if (this.inputRow6.acquisitionDate != "")
                this.inputRow6.acquisitionDate = this.$utils.simpleDateFormat(
                    <Date>this.inputRow6.acquisitionDate,
                    "d"
                );
            this.inputRow6.accountBookId = this.$store.state.accountBook.id;
            this.inputRow6.startPeriod = this.curAccount.startPeriod;
            this.inputRow6.endPeriod = this.curAccount.startPeriod;
            Vue.axios
                .post(
                    `enterpriseincometaxquarterfive?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`,
                    this.inputRow6
                )
                .then(res => {
                    this.$emit("update");
                });
            this.init();
        } else
            this.$message({
                type: "warning",
                message: "请填写完整信息！"
            });
    }
    // 清空附表五新增行
    init() {
        this.inputRow6 = {
            id: null,
            accountBookId: "", //帐套
            startPeriod: "", //起始期间
            endPeriod: "", //结束期间
            name: "", //技术成果名称
            type: "", //技术成果类型
            code: "", //技术成果编号
            fairValue: "", //公允价值
            taxBase: "", //计税基础
            acquisitionDate: "", //取得股权时间（年月日）
            deferredIncome: "", //递延所得
            companyName: "", //企业名称
            taxPayerCode: "", //纳税人识别号
            taxAuthorities: "", //主管税务机关
            investor: "", //与投资方是否为
            remark: "", //备注
            writePeriod: ""
        }
    }
    changeTableFive(row: any) {
        let notNull = this.isNull(row);
        if (notNull && row.acquisitionDate != "") {
            if (row.acquisitionDate != "")
                row.acquisitionDate = this.$utils.simpleDateFormat(<Date>row.acquisitionDate, "d");
            Vue.axios
                .post(
                    `enterpriseincometaxquarterfive?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`, row)
                .then(res => {
                    this.$emit("update");
                });
        } else
            this.$message({
                type: "warning",
                message: "请填写完整信息！"
            });
    }
    //  附表五判断notnull
    isNull(row: any) {
        let notNull = this.$utils.notNull([
            row.name,
            row.type,
            row.code,
            row.fairValue,
            row.taxBase,
            row.acquisitionDate,
            row.deferredIncome,
            row.companyName,
            row.taxPayerCode,
            row.taxAuthorities,
            row.investor
        ]);
        if (notNull) return true;
        else return false;
    }
    // 删除附表五 行
    delRow(id: any) {
        Vue.axios
            .delete(
                `enterpriseincometaxquarterfive?id=${id}`
            )
            .then(res => {
                this.$emit("update");
            });
    }
    // 显示隐藏删除按钮
    curIndex: string = ""
    showIcos(id: any) {
        this.curIndex = id;
    }
    hideIcos() {
        this.curIndex = "";
    }
    selectInner(e: any) {
        this.$nextTick(() => {
            e.target.select();
        });
    }
}
